import __403__dp from './pages/__403__dp'
import __404__dp from './pages/__404__dp'
import __500__dp from './pages/__500__dp'
import __uknown_error__dp from './pages/__uknown_error__dp'
import responsive__403__dp from './responsivePages/__403__dp'
import responsive__404__dp from './responsivePages/__404__dp'
import responsive__500__dp from './responsivePages/__500__dp'
import responsive__uknown_error__dp from './responsivePages/__uknown_error__dp'
import { PageJson } from '@wix/thunderbolt-becky-types'

type PagesMap = {
	[id: string]: PageJson
}

const classicErrorPagesMap = ({
	__403__dp,
	__404__dp,
	__500__dp,
	__uknown_error__dp,
} as any) as PagesMap

const responsiveErrorPagesMap = ({
	__403__dp: responsive__403__dp,
	__404__dp: responsive__404__dp,
	__500__dp: responsive__500__dp,
	__uknown_error__dp: responsive__uknown_error__dp,
} as any) as PagesMap

const getPagesJson = (errorPageId: string, isResponsiveSite: boolean): PageJson | null => {
	const errorPagesMap = isResponsiveSite ? responsiveErrorPagesMap : classicErrorPagesMap

	return errorPagesMap[errorPageId] || null
}

export default getPagesJson
